export const ACTIONS_LOGIN = {
  post_login: "user/postLogin",
};

export const ACTIONS_LOGOUT = {
  logout: "logout/postLogout",
};

export const POST_RESET_PASSWORD = {
  post_reset_password: "resetPassword/postResetPassword",
};

export const POST_FORGOT_PASSWORD = {
  post_forgot_password: "forgotPassword/postForgotPassword",
};

export const ACTION_DOCTOR_APPOINTMENTS = {
  fetch_doctor_appointments: "FETCH_DOCTOR_APPOINTMENTS",
  join_appointment: "JOIN_DOCTOR_APPOINTMENT",
  fetch_doctor_consultation_pricing: "fetch_doctor_consultation_pricing",
};

export const ACTIONS_UPDATE_ONSITE_SCHEDULE = {
  update_onsite_schedule: "consultation/updateOnsiteSchedule",
};

export const ACTIONS_DOCTOR_APPOINTMENTS_PATIENTS = {
  get_list: "doctorAppointmentsPatients/get_list",
};

export const ACTIONS_REQUEST_APPOINTMENT_RESCHEDULE = {
  request: "REQUEST_APPOINTMENT_RESCHEDULE",
};

export const ACTIONS_CREATE_FOLLOWUP_APPOINTMENT = {
  create: "CREATE_FOLLOWUP_APPOINTMENT",
};

export const ACTION_PAYOUT_ACCOUNT = {
  fetch_default_payout_account: "payout/fetchDefaultPayoutAccount",
  save_payout_account: "payout/savePayoutAccount",
  submit_settlement_request: "payout/submitSettlementRequest",
  fetch_provider_settlements: "payout/fetchProviderSettlements",
  fetch_provider_dashboard: "payout/fetchProviderDashboard",
};